module.exports = "<li>\n<div class=\"m\">{month}</div>\n<div class=\"d\">{date}</div>\n<div class=\"w\">{week}</div>\n</li>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./lib/friday/template.html
 ** module id = 19
 ** module chunks = 2
 **/